import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinSubscriptionsRoute: InvariantJiraRoute = {
	name: 'legacy-gin-subscriptions',
	path: '(/secure/|/)ViewSubscriptions([!%]?[\\w]*).jspa',
};
